import { configureStore } from "@reduxjs/toolkit";

import authReducer from "./slices/auth";
import boothReducer from "./slices/booth";
import subdivisionReducer from "./slices/subdivision";
import circleReducer from "./slices/circle";
import stationReducer from "./slices/station";
import sosReducer from "./slices/sos";
import userReducer from "./slices/user";
import routemobileReducer from "./slices/routemobile";
import strikingforceReducer from "./slices/strikingforce";

const store = configureStore({
    reducer: {
        auth: authReducer,
        booth: boothReducer,
        subdivision: subdivisionReducer,
        circle: circleReducer,
        station: stationReducer,
        sos: sosReducer,
        user: userReducer,
        routeMobile: routemobileReducer,
        strikingForce: strikingforceReducer
    },

    devTools: process.env.NODE_ENV !== "production",
});

export default store;